import React, {Component} from 'react';
import {withStyles} from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GeneralInformation from "../Panels/GeneralInformation/";
import Typography from "@material-ui/core/Typography";
import ListDesignerHoc from "../../../../HocHelpers/ListDesignerHoc";
import DataSource from "../Panels/DataSource";
import SampleData from "../Panels/SampleData";
import Chart from "../Panels/Chart";
import Grid from "../Panels/Grid";
import Columns from "../Panels/Columns";
import DeveloperSettings from "../Panels/DeveloperSettings/DeveloperSettings";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary} from "../../../../Utils/ExpansionPanel";

const styles = () => ({
    panelDetails: {
        padding: '0',
        display: 'block'
    }
});

class PanelWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openColumnModal: false,
        }
    }

    onClickWrapper = (action) => {
        const {openColumnModal} = this.state;
        if (action === 'openColumnModal') {
            !openColumnModal && this.setState({openColumnModal: true})
        }
    };

    closeColumnModal = (event) => {
        this.setState({openColumnModal: false});
        event && event.stopPropagation();
    };

    render() {
        const {openColumnModal} = this.state;
        const {panel, classes} = this.props;
        return (
            <ExpansionPanel>
                <ExpansionPanelSummary
                    onClick={() => this.onClickWrapper(panel.action)}
                    expandIcon={<ExpandMoreIcon/>}
                >
                    <Typography>{panel.label}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                    <PanelContentReturn name={panel.name}
                                        closeColumnModal={this.closeColumnModal}
                                        isOpenColumnModal={openColumnModal}/>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

export default ListDesignerHoc(withStyles(styles)(PanelWrapper));


const PanelContentReturn = ({name, closeColumnModal, isOpenColumnModal}) => {

    switch (name) {
        case 'general':
            return <GeneralInformation/>;
        case 'dataSource':
            return <DataSource/>;
        case 'sampleData':
            return <SampleData/>;
        case 'chart':
            return <Chart/>;
        case 'grid':
            return <Grid/>;
        case 'columns':
            return <Columns
                open={isOpenColumnModal}
                close={closeColumnModal}
            />;
        case 'devSettings':
            return <DeveloperSettings/>;
        default:
            return null
    }
};